define('areas/activityfeedconfigurator/models/dto',["require", "exports"], function (require, exports) {
    "use strict";
    var SocialMediaOptions = (function () {
        function SocialMediaOptions() {
        }
        return SocialMediaOptions;
    }());
    exports.SocialMediaOptions = SocialMediaOptions;
    var CchDailyOptions = (function () {
        function CchDailyOptions() {
        }
        return CchDailyOptions;
    }());
    exports.CchDailyOptions = CchDailyOptions;
    var SettingsGenericEntity = (function () {
        function SettingsGenericEntity() {
        }
        return SettingsGenericEntity;
    }());
    exports.SettingsGenericEntity = SettingsGenericEntity;
    var ActivityFeedServiceModel = (function () {
        function ActivityFeedServiceModel() {
        }
        return ActivityFeedServiceModel;
    }());
    exports.ActivityFeedServiceModel = ActivityFeedServiceModel;
    var BillingEmailEntity = (function () {
        function BillingEmailEntity(address, sendInvoice) {
            if (address === void 0) { address = null; }
            if (sendInvoice === void 0) { sendInvoice = true; }
            this.EmailAddress = address;
            this.SendInvoice = sendInvoice;
        }
        return BillingEmailEntity;
    }());
    exports.BillingEmailEntity = BillingEmailEntity;
});

